import { render, staticRenderFns } from "./menuBar.vue?vue&type=template&id=d4ae0fa0&scoped=true"
import script from "./menuBar.vue?vue&type=script&lang=js"
export * from "./menuBar.vue?vue&type=script&lang=js"
import style0 from "./menuBar.vue?vue&type=style&index=0&id=d4ae0fa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ae0fa0",
  null
  
)

export default component.exports